class Controller {
  constructor(Sections, Events, $stateParams) {
    "ngInject";

    this.Events = Events;
    this.$stateParams = $stateParams;
    this.sections = Sections.routesSections;
    this.activeParams = this.$stateParams;
    this.filterEvent = this.Events.getFilterEvent("routes");
    this.addItemEvent = this.Events.getAddEvent("routes");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/routes/routes.controller.js